// extracted by mini-css-extract-plugin
export var cooperationModel = "index-module--cooperationModel--RbjtO";
export var inner = "index-module--inner--z5Tfa";